module.exports = __webpack_public_path__ + "media/images/proof_links/yandexmusic-6ae1b3d73bc6c67ad2c0393663c95ba4.svg";